import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import InventoryReportItem from "../entities/inventoryReportItem";
import appconst from "./../../lib/appconst";
import TransAuditProductItem from "../entities/trans_audit_product_item";
import ReportSerialNo from "../entities/report-serial-no";
import util from "@/lib/util";
interface InventoryReportState extends ListState<InventoryReportItem> {
  transAuditProductItems: TransAuditProductItem[];
  serialNoes: ReportSerialNo[];
  inventoryStatisticsTotalInfo: any;
}
class InventoryReportModule extends ListModule<
  InventoryReportState,
  any,
  InventoryReportItem
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<InventoryReportItem>(),
    loading: false,
    transAuditProductItems: new Array<TransAuditProductItem>(),
    serialNoes: new Array<ReportSerialNo>(),
    inventoryStatisticsTotalInfo: null
  };
  actions = {
    async getAll(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/Inventory/InventoryStatistics",
        { params: payload.data }
      );
      context.state.loading = false;
      context.state.list = result.items as InventoryReportItem[];
      context.state.inventoryStatisticsTotalInfo = result.totalInfo;
      context.state.totalCount = result.totalRows;
    },
    async export(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/inventoryStatistics${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async searchViewOpsTransAudit(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/SearchViewOpsTransAudit",
        { params: payload.data }
      );
      context.state.loading = false;
      let page = reponse.data.result as PageResult<TransAuditProductItem>;
      context.state.totalCount = page.totalCount;
      context.state.transAuditProductItems = page.items;
    },
    async exportViewOpsTransAudit(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/ExportOpsTransAudit${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async reportSerialNoes(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/ReportSerialNoes",
        { params: payload.data }
      );
      context.state.loading = false;
      let page = reponse.data.result as PageResult<ReportSerialNo>;
      context.state.totalCount = page.totalCount;
      context.state.serialNoes = page.items;
    },
    async exportDetailDataSerialNoReportToExcel(
      context: ActionContext<InventoryReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/ExportDetailDataSerialNoReport${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
  };
  mutations = {
    setCurrentPage(state: InventoryReportState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: InventoryReportState, pagesize: number) {
      state.pageSize = pagesize;
    },
    refreshTransAuditList(state: InventoryReportState) {
      state.transAuditProductItems = new Array<TransAuditProductItem>();
    },
  };
}
const inventoryReportModule = new InventoryReportModule();
export default inventoryReportModule;
